import { Component, EventEmitter, Input, Output, TemplateRef, ViewChild } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { iLeadBaja } from '../../interfaces/client';
import { LayoutService } from '../../services/layout.service';
import { NgClass } from '@angular/common';

@Component({
    selector: 'prescp-modal-baja-lead',
    templateUrl: './modal-baja-lead.component.html',
    imports: [FormsModule, ReactiveFormsModule, NgClass]
})
export class ModalBajaLeadComponent {

  modalRef?: BsModalRef;

  formBajaLead = new UntypedFormGroup({
    radioBajaReason: new UntypedFormControl(''),
    observacionesBaja: new UntypedFormControl('')
  });

  mensajeNoMotivo = 'Debe seleccionar alguno de los motivos';
  mensajeNoObservaciones = 'Debe especificar algo en el campo observaciones';
  mensajeModalAdvertencia: string = '';

  modalRef2!: BsModalRef;
  modalRef3!: BsModalRef;

  obsBajaDisabled = true;
  obsBajaContainerDisabled = true;

  @ViewChild('faltaMotivo', {static: true}) faltaMotivoTemplate!: TemplateRef<any>;
  @ViewChild('confirmacion') confirmacionTemplate!: TemplateRef<any>;

  @Input() filaTabla!: iLeadBaja;
  @Output() confirmacionEvento = new EventEmitter<any>();
  @Output() cerrarEvento = new EventEmitter<void>();
  constructor(
    private readonly modalService: BsModalService,
    private readonly _layoutService: LayoutService,
  ) { }

  closeButtonClick(){
    this.cerrarEvento.emit();
  }

  onSubmitBaja() {
    if(this.validateForm()){
      this.openConfirmacionModal(this.confirmacionTemplate);
    }else {
      this.openFaltanMotivosModal(this.faltaMotivoTemplate);
    }
  }

  validateForm(): boolean{
    if(this.formBajaLead.controls.radioBajaReason.value === ''){
      this.mensajeModalAdvertencia = this.mensajeNoMotivo;
      return false;
    }

    if(this.formBajaLead.controls.radioBajaReason.value === 'J' && this.formBajaLead.controls.observacionesBaja.value === ''){
      this.mensajeModalAdvertencia = this.mensajeNoObservaciones;
      return false;
    }

    return true;
  }

  enviarMensajeError(mensaje: string) {
    this._layoutService.showAlert({
      textDescription: mensaje,
      textBtnClose: "De acuerdo",
      classIcon: "icon-error",
    });
  }

  openFaltanMotivosModal(template: TemplateRef<any>){
    this.modalRef2 = this.modalService.show(template,
      {
        class: 'second',
        ignoreBackdropClick: true
      }
    );
    const secondModal = document.querySelector('.second .modal-content') as HTMLElement;
    secondModal.style.backgroundColor = 'rgba(239, 246, 247, 1)';
  }

  openConfirmacionModal(template: TemplateRef<any>){
    this.modalRef3 = this.modalService.show(template,
      {
        class: 'second',
        ignoreBackdropClick: true
      }
    );
    const secondModal = document.querySelector('.second .modal-content') as HTMLElement;
    secondModal.style.backgroundColor = 'rgba(239, 246, 247, 1)';
  }

  onSubmitConfirmacion(){
    const reasonVar = this.formBajaLead.controls.radioBajaReason.value;
    const commentVar = this.formBajaLead.controls.observacionesBaja.value;

    this.modalRef3.hide();

    this.confirmacionEvento.emit(
      {
        row: this.filaTabla,
        reason: reasonVar,
        comment: commentVar
      }
    );
  }

  bajaReasonChange(): void{
    if (this.formBajaLead.value.radioBajaReason === 'J') {
      this.obsBajaDisabled = false;
      this.obsBajaContainerDisabled = false;
    } else {
      this.obsBajaDisabled = true;
      this.obsBajaContainerDisabled = true;
    }
  }
}
